import client from "./client";

export type Plan = "full" | "half" | "quarter";
export type Currency = "USD" | "EUR" | "AZN" | "BYN" | "GEL" | "KZT" | "KGS" | "TRY";

export const stripeApi = {
  checkout: (body: { email: string; plan: Plan; currency: Currency; promoCode?: string }) =>
    client.post<{ url: string; sessionId: string }>("/stripe/checkout", body),

  remainder: () =>
    client.post<{ url: string; sessionId: string }>("/stripe/remainder"),

  credentials: (sessionId: string) =>
    client.get<{ userId: number; username: string; password: string; token: string }>(
      `/stripe/session/${sessionId}/credentials`,
    ),

  validatePromo: (code: string) =>
    client.get<{ valid: boolean; code: string; discountPercent: number; expiresAt: string }>(
      `/promo-codes/${encodeURIComponent(code)}/validate`,
    ),
};
